import TotalEggsWidgetContainer from "./TotalEggsWidgetContainer";
export type { TotalEggsApiResponse } from "./TotalEggs";

export default TotalEggsWidgetContainer;
